import { createFeatureSelector } from '@ngrx/store';
import * as fromMap from './map.reducer';
import * as fromLocationHistory from './location-history.reducer';
import * as fromLocationFilters from './location-filters.reducer';

export const getLocationMapState = createFeatureSelector<fromMap.State>(
  fromMap.locationFeatureKey,
);
export const selectLocationHistoryState =
  createFeatureSelector<fromLocationHistory.State>(
    fromLocationHistory.locationHistoryFeatureKey,
  );
export const selectLocationFilterState =
  createFeatureSelector<fromLocationFilters.State>(
    fromLocationFilters.locationFiltersFeatureKey,
  );
